import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { hideHeader, hideLogoAndFooter, changeBgColor } from "../../../actions/appStatus.actions";

export const CardControlsIneligibilityPageComponent = (props) => {

useEffect(() => {
    props.hideLogoAndFooter();
    props.hideHeader();
    props.changeBgColor("#fcfdfe");
    }, []);

  return (
    <div className="card-controls-error-page">
      <br />
      <div className="text-centered">Please call us for help with managing your Lake Trust Debit  Card(s) at 888-267-7200.</div>
    </div>
  );
};

const mapDispatchToProps = {
    hideHeader,
    changeBgColor,
    hideLogoAndFooter
  };

  const mapStateToProps = (state) => state;
  
  const CardControlsIneligibilityPage = withRouter(
    connect(mapStateToProps, mapDispatchToProps)(CardControlsIneligibilityPageComponent)
  );
  
  export default CardControlsIneligibilityPage;


// WEBPACK FOOTER //
// ./src/components/card-controls/ineligibility-page/card-controls-ineligibility-page.component.js